<template>
  <div id="g-timeaxis" @mousedown.stop="onMousedown($event)" @mouseup.stop="onMouseup($event)"
    @mouseleave.stop="onMouseleave($event)">
    <div class="g-timeaxis-empty-space" :style="{ width: rowLabelWidth, background: themeColors.ternary }">
      <slot name="pp-head-left"></slot>
    </div>
    <div v-if="intert != 24" class="g-timeaxis-days" :style="{ width: `${100 - rowLabelWidth.replace('%', '')}%` }">
      <div v-for="day in axisDays" :key="day.text" class="g-timeaxis-day border-s" :style="{
        width: day.widthPercentage + '%',
        background: themeColors.ternary,
        color: themeColors.text
      }">
        <div class="text-black border-s">{{ dayFormatted(day) }}</div>
        <div :style="{ background: themeColors.ternary, color: themeColors.text }">
          <div v-for="hour in day.ganttHours" :key="hour.fullDatetime" class="g-timeaxis-hour text-s border-s">
            {{ parseInt(hour.text) + intert + ' : 00' }}
            <!-- <div class="g-timeaxis-hour-pin" :style="{ background: themeColors.text }" /> -->
            <!-- <div class="g-time-line"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div v-else class="g-timeaxis-days" :style="{ width: `${100 - rowLabelWidth.replace('%', '')}%` }">
      <div v-for="month in axisMounths" :key="month.text" class="g-timeaxis-day border-s" :style="{
        width: month.widthPercentage + '%',
        background: themeColors.ternary,
        color: themeColors.text
      }">
        <div class="text-black border-s">{{ monthFormatted(month) }}</div>
        <div :style="{ background: themeColors.ternary, color: themeColors.text }">
          <div v-for="day in month.ganttDays" :key="day.fullDatetime" class="g-timeaxis-hour text-s border-s">
            {{ day.text }}
            <!-- <div class="g-timeaxis-hour-pin" :style="{ background: themeColors.text }" /> -->
          </div>
        </div>
      </div>
    </div>
    <div id="g-timeaxis-marker">
      <div style="height: 50%; width: 2px; background: black"></div>
      <div style="height: 50%; padding-top: 5px" class="text-bold font-md">{{ timeCurrent }}</div>
    </div>
    <!-- <div id="g-timeaxis-tips">{{ timeCurrent }}</div> -->
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'GGanttTimeaxis',
  props: {
    chartStart: String,
    chartEnd: String,
    rowLabelWidth: String,
    timemarkerOffset: { type: Number, default: 0 },
    locale: String,
    themeColors: Object,
    intert: Number,
    barcontainer: {
      type: DOMRect
    }
  },

  inject: ['ganttChartProps', 'getThemeColors', 'getHourCount', 'getChartStart', 'getChartEnd'],
  components: {
    PpStationSelector: () => import('@/views/pp/components/PpStationSelector')
  },

  data () {
    return {
      axisDays: [],
      axisMounths: [],
      hourCount: null,
      timemarker: null,
      timemarker2: null,
      hourFontSize: '11px',
      dayFormat: 'MM-DD ddd',
      monthFormat: 'YYYY MMMM',
      stationid: 0,
      timemove: false,
      conX: null,
      timeSta: '2022-01-07 00:00',
      moveXXX: false,
      timeCurrent: null
    }
  },

  computed: {
    allhourCount () {
      return (new Date(this.chartEnd).valueOf() - new Date(this.chartStart).valueOf()) / 3600000
    }
  },

  mounted () {
    this.timemarker = document.querySelector('#g-timeaxis-marker')
    // this.timemarker2 = document.querySelector('#g-timeaxis-tips')
    if (this.intert != 24) {
      this.initAxisDaysAndHours()
    } else {
      this.initAxisMounthsAndDays()
    }
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize)
    window.addEventListener('mousemove', event => this.moveTimemarker(event))
    window.addEventListener('dragover', event => this.moveTimemarker(event))
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    mapPositionToTime (xPos) {
      let hourDiffFromStart = (xPos / this.barcontainer.width) * this.getHourCount()
      return moment(this.chartStart).clone().add(hourDiffFromStart, 'hour')
    },

    mapTimeToPosition (time) {
      let hourDiffFromStart = moment(time).diff(this.chartStart, 'hour', true)
      return (hourDiffFromStart / this.getHourCount()) * this.barcontainer.width
    },

    onMousedown (e) {
      e.preventDefault()
      this.conX = e.clientX
      window.addEventListener('mousemove', this.moveTimeaxis)
    },
    onMouseup (e) {
      e.preventDefault()
      window.removeEventListener('mousemove', this.moveTimeaxis)
      if (this.moveXXX) this.endMove()
    },
    onMouseleave (e) {
      e.preventDefault()
      window.removeEventListener('mousemove', this.moveTimeaxis)
      if (this.moveXXX) this.endMove()
    },

    endMove () {
      var start = moment(this.chartStart)
      var barStartMoment = null
      var tmp = null
      var barEndMoment = null

      let hour = start.hour() % this.intert
      barStartMoment = moment(start.add(this.intert - hour, 'hour').startOf('hour'))

      tmp = moment(barStartMoment.format('YYYY-MM-DD HH:mm')).valueOf() + this.allhourCount * 60 * 60 * 1000

      barEndMoment = moment(tmp)
      this.moveXXX = false

      this.$emit('timeaxis', [barStartMoment, barEndMoment])
    },

    moveTimeaxis (e) {
      this.moveXXX = true

      let newXStart = this.conX - e.clientX
      this.conX = e.clientX
      let newXEnd = newXStart + this.barcontainer.width
      let barStartMoment = this.mapPositionToTime(newXStart)

      let barEndMoment = this.mapPositionToTime(newXEnd)
      this.$emit('timeaxis', [barStartMoment, barEndMoment])
    },

    initAxisDaysAndHours () {
      this.axisDays = []
      let start = moment(this.chartStart)
      let end = moment(this.chartEnd)
      let interv = this.intert
      this.hourCount = Math.floor(end.diff(start, 'hour', true))
      while (start.diff(end, 'hour') < 0) {
        let hourCountOfDay = start.format('DD.MM.YYYY') == end.format('DD.MM.YYYY') ? end.hour() : 24 - start.hour()
        let widthPercentage = (hourCountOfDay / this.hourCount) * 100

        // -1 because the last hour is not included e.g if chartEnd=04:00 the last interval we display is between 03 and 04
        let xv = this.getAxisDayObject(start, widthPercentage, interv, hourCountOfDay)
        this.axisDays.push(xv)
        start.add(1, 'd').hour(0)
      }
      this.$store.commit('SET_AXIS_DAY', this.axisDays)
    },
    getAxisDayObject (datetime, widthPercentage, interv, hourCountOfDay) {
      let datetimeMoment = moment(datetime)
      let axisDayObject = {
        widthPercentage: widthPercentage,
        value: datetime.format('YYYY-MM-DD'),
        ganttHours: []
      }
      var i = 0
      if (interv == 1) {
        i = 0
      } else {
        i = 1
      }
      for (i; i < hourCountOfDay; i = i + interv) {
        let hour = {
          text: parseInt(datetimeMoment.format('HH') / interv) * interv,
          fullDatetime: datetimeMoment.format('YYYY-MM-DD HH:mm')
        }
        axisDayObject.ganttHours.push(hour)
        datetimeMoment.add(interv, 'h')
      }

      return axisDayObject
    },

    initAxisMounthsAndDays () {
      this.axisMounths = []
      var start = moment(this.chartStart)
      let end = moment(this.chartEnd)

      this.dayCount = Math.floor(end.diff(start, 'day', true))
      while (start.diff(end, 'day') < 0) {
        let dayCountOfDay = start.format('MM.YYYY') != end.format('MM.YYYY') ? start.daysInMonth() - start.get('date') + 1 : end.get('date') - 1
        let widthPercentage = (dayCountOfDay / this.dayCount) * 100
        let xv = this.getAxisMounthObject(start, widthPercentage, end, dayCountOfDay)
        this.axisMounths.push(xv)
        start.add(dayCountOfDay * 24, 'hour')
      }
      this.$store.commit('SET_AXIS_MONTH', this.axisMounths)
    },

    getAxisMounthObject (datetime, widthPercentage, end, dayCountOfDay) {
      let datetimeMoment = moment(datetime)
      let axisDayObject = {
        widthPercentage: widthPercentage,
        value: datetimeMoment.format('YYYY-MM-DD'),
        ganttDays: []
      }

      for (let i = 0; i < dayCountOfDay; i++) {
        let day = {
          text: datetimeMoment.format('DD'),
          fullDatetime: datetimeMoment.format('YYYY-MM-DD HH:mm')
        }
        axisDayObject.ganttDays.push(day)
        datetimeMoment.add(1, 'd')
      }
      return axisDayObject
    },

    moveTimemarker (event) {
      let position = event.clientX - this.timemarkerOffset - this.horizontalAxisContainer.left
      this.timemarker.style.left = position - 24 + 'px'
      // this.timemarker2.style.left = position + 5 + 'px'
      this.timeCurrent = this.mapPositionToTime(event.clientX - this.barcontainer.left).format('HH:mm')
    },

    onWindowResize () {
      this.horizontalAxisContainer = document.querySelector('#g-timeaxis').getBoundingClientRect()
      this.hourFontSize = Math.min(9.5, 0.75 * (this.horizontalAxisContainer.width / this.hourCount)) + 'px'
    },

    dayFormatted (day) {
      // do not display day text if the day is smaller than 12%
      return moment(day.value).locale(this.locale).format(this.dayFormat)
    },
    monthFormatted (month) {
      return moment(month.value).locale(this.locale).format(this.monthFormat)
    }
  },

  watch: {
    chartStart () {
      if (this.intert != 24) {
        this.initAxisDaysAndHours()
      } else {
        this.initAxisMounthsAndDays()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.g-timeaxis-days,
.g-timeaxis-day,
.g-timeaxis-day>div {
  display: flex;
  overflow: hidden;
}

.border-s {
  border: 1px solid #eef0f0;
  border-right: 1px solid transparent;
}

.text-s {
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #999999;
}

.bg-day {
  background-color: rgba(248, 249, 252, 1);
}

#g-timeaxis {
  position: sticky;
  display: flex;
  top: 0;
  width: 100%;
  height: 60px;
  background: white;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  z-index: 4;
  /* box-shadow: 0px 1px 3px 2px rgba(50, 50, 50, 0.5); */
}

#g-timeaxis>.g-timeaxis-empty-space {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  padding: 10px 8px;
  width: 20%;
  /* this has to be as wide as .ganttRowTitle in VGanttastic.css */
  height: 60px;
  background: #f5f5f5;
  border-top: 1px solid #eaeaea;
  border-left: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
}

#g-timeaxis>.g-timeaxis-days {
  position: relative;
  height: 60px;
}

.g-timeaxis-day {
  height: 100%;
  flex-direction: column;
  background: #e0e0e0;
}

.g-timeaxis-day:nth-child(odd) {
  background: #e8e8e8;
}

.g-timeaxis-day>div:nth-child(1) {
  /* day text */
  height: 50%;
  justify-content: space-around;
  font-weight: bold;
  align-items: center;
}

.g-timeaxis-day>div:nth-child(2) {
  /* hours of a day */
  align-items: flex-end;
  height: 50%;
  justify-content: space-between;
  background: #f5f5f5;
  padding-top: 2px;
  color: #212121;
}

.g-timeaxis-hour {
  display: flex;
  flex: 1;
  align-items: center;
  flex-direction: column;
  opacity: 0.8;

  width: 100%;
}

.g-timeaxis-hour-pin {
  width: 1px;
  height: 8px;
}

#g-timeaxis-marker {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 50px;
  text-align: center;
  height: 100%;
}

#g-timeaxis-tips {
  position: absolute;
  top: 2px;
  left: 0;
}
</style>

